import React, { FC } from 'react';
import PopUp from 'components/PopUps/PopUp';
import PopUpContent from 'components/PopUps/PopUpContent';
import Button from 'components/Button';
import styles from './DeleteTemplatePopUp.module.scss';

interface DeleteTemplatePopUpProps {
  onPopupClose: () => void;
  onDeleteTemplate: () => void;
  isDeleteInProgress: boolean;
}

const DeleteTemplatePopUp: FC<DeleteTemplatePopUpProps> = ({ onPopupClose, onDeleteTemplate, isDeleteInProgress }) => {
  return (
    <PopUp title="Delete Template" closePopUp={onPopupClose} closable={!isDeleteInProgress}>
      <PopUpContent className={styles.popupContent} hasTopMargin>
        <p className={styles.deleteTemplateQuestion}>Please confirm that you would like to delete template.</p>
        <Button
          kind="primary"
          size="form"
          className={styles.deleteTemplateButton}
          onClick={onDeleteTemplate}
          isLoading={isDeleteInProgress}
        >
          Yes, Delete Template
        </Button>
        <Button
          kind="secondary"
          size="form"
          className={styles.goBackButton}
          onClick={onPopupClose}
          disabled={isDeleteInProgress}
        >
          No, Go Back
        </Button>
      </PopUpContent>
    </PopUp>
  );
};

export default DeleteTemplatePopUp;
